import {useViewer} from '@github-ui/item-picker-assignee-relay/useViewer'
import type {AssigneePickerAssignee} from '@github-ui/item-picker-assignee-tsq'
import {AssigneeRepositoryPicker} from '@github-ui/item-picker-assignee-tsq'
import {formatActorLogin} from '@github-ui/item-picker-assignee-tsq/utils/assignee-picker'
import {getTokensByType, replaceAllFiltersByTypeInSearchQuery} from '@github-ui/filter-query'
import {useCallback, useMemo} from 'react'

import {createQuickFilterAnchor, type QuickFilterProps} from './quick-filter-shared'

const authorAnchor = createQuickFilterAnchor('Author')
const assigneeAnchor = createQuickFilterAnchor('Assignee')

type ActorQuickFilterProps = QuickFilterProps & {
  kind: 'assignee' | 'author'
}

function ActorQuickFilter({kind, owner, query, repo, onQueryChange}: ActorQuickFilterProps) {
  const viewer = useViewer()
  const tokens = useMemo(() => getTokensByType(query, kind).slice(-1), [kind, query])
  const isAuthor = kind === 'author'
  const anchor = isAuthor ? authorAnchor : assigneeAnchor
  const onSelectionChange = useCallback(
    (actors: AssigneePickerAssignee[]) => {
      onQueryChange(replaceAllFiltersByTypeInSearchQuery(query, actors.map(formatActorLogin), kind), kind)
    },
    [kind, onQueryChange, query],
  )

  return (
    <AssigneeRepositoryPicker
      name={kind}
      selectionVariant="single"
      readonly={false}
      title={`Filter by ${kind}`}
      assigneeTokens={tokens}
      assignees={[]}
      repo={repo}
      owner={owner}
      viewer={viewer}
      onSelectionChange={onSelectionChange}
      anchorElement={anchor}
      showNoMatchItem
      includeAuthorableBots={isAuthor}
      includeAssignableBots={!isAuthor}
    />
  )
}

export function AuthorQuickFilter(props: QuickFilterProps) {
  return <ActorQuickFilter {...props} kind="author" />
}

export function AssigneeQuickFilter(props: QuickFilterProps) {
  return <ActorQuickFilter {...props} kind="assignee" />
}
